import script from "./FactoryShowView.vue?vue&type=script&setup=true&lang=js"
export * from "./FactoryShowView.vue?vue&type=script&setup=true&lang=js"

import "./FactoryShowView.vue?vue&type=style&index=0&id=46a6e4b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46a6e4b8"]])

export default __exports__